import { ReactEventHandler } from 'react';

import type { RelativeAbsolutePosition } from '../../../../core/types/pointer-events.js';
import { ZOOM_CHANGE_TYPE } from '../../../../core/types/zoom.js';
import { useXYChartData } from '../../../hooks/useXYChartData.js';
import { useXYChartScales } from '../../../hooks/useXYChartScales.js';
import { reduceResetInteractions } from '../../../store/reducer-reset.js';
import { useSetState } from '../../../store/selectors.js';
import { isZoomEnabledFor } from '../../../utils/axis-interactions.js';
import { getInitialScale } from '../../../utils/get-scale.js';
import { handleZoomChange } from '../utils/zoom-change-handler.js';

export const useResetInteractions = () => {
  const setState = useSetState();
  const { axesMetadata, axes } = useXYChartData();
  const axisIdToScales = useXYChartScales();

  return (
    event?: Partial<ReactEventHandler> & {
      position?: RelativeAbsolutePosition;
    },
  ) => {
    for (const axis of axes) {
      if (isZoomEnabledFor(axis)) {
        const initialScale = getInitialScale(axisIdToScales, axis.id);
        const initialDomain = initialScale.domain() as number[] | Date[];

        handleZoomChange(
          axis,
          initialDomain[0],
          initialDomain[1],
          ZOOM_CHANGE_TYPE.Reset,
        );
      }
    }

    setState(
      reduceResetInteractions({
        position: event?.position,
        zoomStatus: {
          zoomOutEnabled: axesMetadata.isInfinite,
        },
      }),
    );
  };
};
